import React from "react";
import shareYourJourneyImage from '../../images/shareYourJourneyImage.jpg';
import professionalDevelopmentImage from '../../images/professionalDevelopment.jpg';
import enggCoursesImage from '../../images/enggCourses.jpg';
import './home.css';
import Header from "../basic/Header";
import ContactUs from "../basic/contactUs";
import config from "../../config/config";
import YoutubeEmbedVideo from "../basic/YoutubeEmbedVideo";

class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div>
                <Header title={'Engineering Guru'} subTitleText={"An initiative to provide effective guidance to upcoming engineering graduates to help them learn, define and drive their career in a successful manner"}/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mb-3">
                            <h2>What We Do</h2>
                            <hr />
                                <p>In the current education system, there is a perceptible disconnect between the students, faculty and managements of engineering colleges.</p>
                                <p>Freshly minted graduates are not really career-ready to take on the task of developing and maintaining the world’s computer systems, or build the next-generation killer engineering product.</p>
                                <p>Inorder for them to be successful in the industry, they should be brought up in a streamlined process, where one <b>learns things</b> instead of <b>studying things</b> just for the sake of grades.</p>
                                <p>We, as a team of concerned individuals, are striving to build a platform that can guide the upcoming engineers in the right direction and help them learn, define and drive their career in a successful manner.</p>
                                <p>We run a variety of programs for students to make them industry ready, also helping them connect, interact and learn from industry professionals. Join us to explore more.</p>
                                <a className="btn btn-info btn-lg" href={config.rootPath+config.joinUsPath}>Come Join Us &raquo;</a>
                        </div>
                        <div className="col-md-4 mb-3">
                            <ContactUs />
                            <YoutubeEmbedVideo
                                url={config.rootPath+config.youTubeVideoUrl}
                                height={'15em'}
                            />
                        </div>
                    </div>
                    <hr style={{padding: "0px"}}/>
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <div className="card h-100">
                                <img className="card-img-top" src={shareYourJourneyImage} alt="" />
                                    <div className="card-body">
                                        <h4 className="card-title">Share your thought process</h4>
                                        <p className="card-text">Help others choose their path by sharing some details of your journey such as, </p>
                                        <ul>
                                            <li>What career path you chose</li>
                                            <li>Why you chose that path</li>
                                            <li>What were the driving factors</li>
                                            <li>What you have become now by following those steps</li>
                                        </ul>
                                    </div>
                                    <div className="card-footer d-flex justify-content-center">
                                        <a href={config.rootPath+config.shareYourJourneyPath} className="btn btn-info">Share your Journey details!</a>
                                    </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card h-100">
                                <img className="card-img-top" src={professionalDevelopmentImage} alt="" />
                                    <div className="card-body">
                                        <h4 className="card-title">Professional Development</h4>
                                        <p className="card-text">Professional development refers to the continued training and education of an individual in regards to his or her career. </p>
                                        <p className="card-text">The goal of professional development is to keep you up-to-date on current trends as well as help you develop new skills for the purpose of advancement in the field. </p>
                                    </div>
                                <div className="card-footer d-flex justify-content-center">
                                    <a href={config.rootPath+config.professionalDevelopmentPath} className="btn btn-info">Find out More!</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card h-100">
                                <img className="card-img-top" src={enggCoursesImage} alt="" />
                                    <div className="card-body">
                                        <h4 className="card-title">Engineering Courses</h4>
                                        <p className="card-text">This is a program designed to look back at the topics that you learn during the Engineering course work and help get the basics right.</p>
                                        <p className="card-text">The goal of this program is to focus more on the basics of each course and build a overall picture by emphasizing what and why you should learn it the right way. </p>
                                    </div>
                                    <div className="card-footer d-flex justify-content-center">
                                        <a href={config.rootPath+config.engineeringCoursesPath} className="btn btn-info" aria-disabled={"true"}>Find out More!</a>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Home.propTypes = {};

export default Home;
